import React, { useState } from "react";
import { useTypedSelector, useUpdateStatusMutation } from "../../store";
import { twMerge } from "tailwind-merge";
import classNames from "classnames";
import { showToast, ToastType } from "../../utils/toast.utils";

function SlideSwitch() {
  const restaurant = useTypedSelector((state) => state.session.restaurant);
  const [isOn, setIsOn] = useState<boolean>(restaurant?.isActive || false);
  const [updateStatus] = useUpdateStatusMutation();

  const toggle = async () => {
    const result = await updateStatus({ isActive: !isOn });
    if (!result.error) {
      setIsOn(result.data.isActive);
      showToast("Statut mis à jour", ToastType.SUCCESS);
    }
  };

  const containerClasses = twMerge(
    classNames(
      "w-12 h-6 flex items-center rounded-full p-1 cursor-pointer transition-colors duration-300 bg-gray-300",
      {
        "bg-primary/70": isOn,
      }
    )
  );

  const toggleClasses = twMerge(
    classNames(
      "w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-300 translate-x-0",
      {
        "translate-x-6": isOn,
      }
    )
  );

  return (
    <div className="flex items-center gap-2 mx-4">
      <div className="bg-white p-0.5 rounded-full">
        <div
          onClick={toggle}
          className={containerClasses}
        >
          <div className={toggleClasses} />
        </div>
      </div>
      <div className="font-semibold text-lg">
        {isOn ? (
          <div className="text-primary"> Actif </div>
        ) : (
          <div className="text-gray-600"> Inactif </div>
        )}
      </div>
    </div>
  );
}

export default SlideSwitch;
